import {
  DesignProject,
  UpdateManyProjectElementsDto,
  DesignProjectOnboardingBudget,
  InstallLocation,
} from "@yardzen/api-dtos";
import { AxiosResponse } from "axios";
import { apiClient } from "../base-client";

const baseUrl = "accounts";

export async function getOnboardingSteps(
  accountId: string,
  designProjectId: string,
): Promise<AxiosResponse<DesignProject>> {
  return apiClient.get(
    `${baseUrl}/${accountId}/design-projects/${designProjectId}/onboarding`,
  );
}

export async function upsertWishlistProjectElement(
  accountId: string,
  designProjectId: string,
  stepId: string,
  projectElementName: string,
  data: {
    selectedPriceLow?: number | null;
    selectedPriceHigh?: number | null;
    installLocation?: InstallLocation[] | null;
    selectedStyle?: string | null;
    notes?: string;
    priority?: number;
  },
) {
  return apiClient.put(
    `${baseUrl}/${accountId}/design-projects/${designProjectId}/onboarding/${stepId}/project-elements/${projectElementName}`,
    data,
  );
}

export async function deleteWishlistProjectElement(
  accountId: string,
  designProjectId: string,
  stepId: string,
  projectElementName: string,
) {
  return apiClient.delete(
    `${baseUrl}/${accountId}/design-projects/${designProjectId}/onboarding/${stepId}/project-elements/${projectElementName}`,
  );
}

export async function updateWishlistProjectElementsBatch(
  accountId: string,
  designProjectId: string,
  stepId: string,
  updates: UpdateManyProjectElementsDto[],
) {
  return apiClient.put(
    `${baseUrl}/${accountId}/design-projects/${designProjectId}/onboarding/${stepId}/project-elements`,
    updates,
  );
}

export async function updateDesignProjectOnboardingBudget(
  accountId: string,
  designProjectId: string,
  fields: Partial<DesignProjectOnboardingBudget>,
) {
  return apiClient.patch(
    `${baseUrl}/${accountId}/design-projects/${designProjectId}/onboarding/budget`,
    fields,
  );
}
